<div class="modal-header">
	<h4 class="modal-title">ePractice Manager Trial Update!</h4>
</div>
<div class="modal-body">
	<p>Your 30-day trial is underway! Just a reminder that it will expire on {{expire}}.</p>
	<p *ngIf="first">
		Please check your email for all account details, and to confirm your email address.
	</p>
	<p>For uninterrupted access, <a style="outline:none;" (click)="closePopUp()" routerLink="/ang/Payment/Upgrade">click here to upgrade your account</a></p>

</div>